import React from 'react';
import { Button, IconNames } from '@dotcom/crown-ui';
import { IconButton } from '../icon-button/icon-button';
import { NavigationButtonsProps } from './navigation-buttons-types';
import styles from './navigation-buttons.module.scss';

export const NavigationButtons = ({ secondaryActionButton, primaryActionButton }: NavigationButtonsProps) => {
  return (
    <div className={styles['navigation-buttons']}>
      <IconButton
        onClick={secondaryActionButton.onClick}
        variant="link"
        testId={secondaryActionButton.testId || `secondary-navigation-button-${secondaryActionButton.text}`}
        className={styles['secondary-action-button']}
        label={secondaryActionButton.text}
        iconPosition="left"
        iconSize="14"
        iconName={IconNames.ArrowsCaretDown}
      />

      <Button
        tabIndex={-1}
        type="button"
        variant="primary"
        onClick={primaryActionButton.onClick}
        aria-label={primaryActionButton.ariaLabel || 'primary-action-button'}
        disabled={primaryActionButton.isDisabled}
        testId={primaryActionButton.testId || `primary-navigation-button-${primaryActionButton.text}`}
        className={styles['primary-action-button']}
      >
        {primaryActionButton.text}
      </Button>
    </div>
  );
};
